import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { Oval } from "react-loader-spinner";
import { FileUpload } from "primereact/fileupload";

import { Button, CalendarField, TextInputField } from "../../../helpers";
import Tooltip from "../../../helpers/Tooltip";
import FileViewAndRemove from "../../../common/FileViewAndRemove";

import DeletePI from "./DeletePI";
import EditPIPunch from "./EditPIPunch";
import UploadEInvoiceModal from "./UploadEInvoiceModal";

import "../index.css"

import { cancelSellerGRNQCPunchBySellerPIPunchId } from "../../../services/api/sellerGRNQCPunch";
import { updateEInvoiceOnSellerPIPunch, updateSellerPIPunchSkipVerification, updateSellerPIPunchToHighPriority } from "../../../services/api/sellerPIPunch";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { updateSellerPIPunch } from "../../../services/api/sellerPIPunch";

import { getBranchComparision, getDateString, getDateTimeString, getFullName, getGRNProcessingStatus, getMaterialMasterDetailsTooltip, numberConversion, checkPermissions } from "../../../utils";
import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";


const PIReceivedProductDetails = (props) => {
    let {
        sellerPO,
        sellerPIPunch, 
        sellerPIPunchItems, 
        sellerGRNQCPunch, 
        PIPunchBookingLogs,
        materialDetails, 
        materialBrands, 
        fileUploadHandler, 
        handleSellerPIChange, 
        handleEditClick, 
        handleSaveClick, 
        handleDeleteSellerPIPunch, 
        PIPunchCreatedUsers,
        adjustmentNotes,
        adjustmentNoteItems,
        setIsLoaderVisible,
        setSellerGRNQCPunch,
        piPunchErrors,
        isLoading,
        piPunchImageName,
        approvalInstances, 
        setSellerPIPunch,
        processLineItems,
        sellerPIPunchTickets,
        isLoaderVisible,
        ticketSubCategoies,
        approvals
    } = props

    const [visibleSellerEInvoiceModal, setVisibleSellerEInvoiceModal] = useState(false)

    const [selectedSellerPIPunch, setSelectedSellerPIPunch] = useState(null)

    sellerPIPunch = _.sortBy(sellerPIPunch, "sellerPIPunchId")

    const dispatch = useDispatch()

    const usersData = useSelector(state => state?.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(usersData.PMCompanyDetails.companyId)
    let { numberLocale } = pmCompanyConfig
   
    const handleChange = (e, sellerPIPunchId) => {
        handleSellerPIChange(e, sellerPIPunchId)
    }

    const handleDelete = (sellerPIPunchId) => {
        const relatedSellerGRNQCPunch = sellerGRNQCPunch?.filter(eachSellerGRNQCPunch => eachSellerGRNQCPunch?.sellerPIPunchId === sellerPIPunchId && eachSellerGRNQCPunch?.statusId === 1)
        const relatedSellerPIPunch = sellerPIPunch.find(eachSellerPIPunch => eachSellerPIPunch.sellerPIPunchId === sellerPIPunchId)
        if (relatedSellerGRNQCPunch?.length > 0){
            dispatch(raiseToast({severity:'error', detail: "GRN is Done. PI Punch Can't Be Deleted.", life: 3000}))
        }else{
            let confirmationText = "Are you sure you want to delete the PI?"
            if(relatedSellerPIPunch.verifiedBy){
                confirmationText = "PI is already verified. Are you sure you want to delete the PI?"
            }

            if (window.confirm(confirmationText)){
                handleDeleteSellerPIPunch(sellerPIPunchId)
            }
        }
    }

    const handleDeleteGRN = async (sellerPIPunchId) => {
        const relatedAdjustmentNotes = adjustmentNotes?.find(eachAdjustmentNote => eachAdjustmentNote?.sellerPIPunchId === sellerPIPunchId && eachAdjustmentNote?.statusId !== 6)
        if (relatedAdjustmentNotes?.adjustmentNoteId){
            dispatch(raiseToast({severity:'error', detail: "GRN Can't Be Deleted as it has Active Debit Note. Please Delete the Debit Note before cancel the grn.", life: 3000}))
        }else{
            if (window.confirm("Are you sure you want to delete the GRN & QC...?")){
                setIsLoaderVisible(true)
                const relatedSellerGRNQCPunch = sellerGRNQCPunch?.filter(eachSellerGRNQCPunch => eachSellerGRNQCPunch?.sellerPIPunchId === sellerPIPunchId)
                let recentSellerGRNQCPunch = _.maxBy(relatedSellerGRNQCPunch, "sellerGRNQCPunchId")
                let data = {
                    sellerGRNQCPunch: recentSellerGRNQCPunch
                }
                const updatedRes = await cancelSellerGRNQCPunchBySellerPIPunchId(sellerPIPunchId, data)
                if (updatedRes?.failure){
                    dispatch(raiseToast({severity:'error', detail: "GRN is Not Deleted", summary: updatedRes?.data?.error, life: 3000}))
                }else{
                    dispatch(raiseToast({severity:'success', detail: "GRN is Deleted Successfully.", life: 3000}))
                    const updatedSellerGRNQCPunch = sellerGRNQCPunch?.map(eachSellerGRNQCPunch => {
                        const relatedSellerGRNQCPunch = updatedRes?.data?.find(eachUpdatedSellerGRNQCPunch => eachUpdatedSellerGRNQCPunch?.sellerGRNQCPunchId === eachSellerGRNQCPunch?.sellerGRNQCPunchId)
                        if (relatedSellerGRNQCPunch?.sellerGRNQCPunchId){
                            return relatedSellerGRNQCPunch
                        }else{
                            return eachSellerGRNQCPunch
                        }
                    })
                    setSellerGRNQCPunch(updatedSellerGRNQCPunch)
                }
                setIsLoaderVisible(false)
            }
        }
    }

    const handleRaisePriority = async (relatedSellerPIPunch) => {
        const relatedSellerGRNQCPunch = sellerGRNQCPunch.filter(eachSellerGRNQCPunch => eachSellerGRNQCPunch.sellerPIPunchId === relatedSellerPIPunch.sellerPIPunchId && eachSellerGRNQCPunch.statusId === 1)
        const relatedSellerPIPunchItems = sellerPIPunchItems.filter(eachSellerPIPunchItem => eachSellerPIPunchItem.sellerPIPunchId === relatedSellerPIPunch.sellerPIPunchId)
        let isSellerPIPunchProcessed = getGRNProcessingStatus({sellerPIPunchItems: relatedSellerPIPunchItems, sellerGRNQCPunches: relatedSellerGRNQCPunch})
        if(!isSellerPIPunchProcessed){
            return dispatch(raiseToast({ severity: 'error', detail: "GRN is not fully processed!" }))
        }

        setIsLoaderVisible(true)
        const sellerPIPunchRes = await updateSellerPIPunchToHighPriority({ sellerPIPunchId: relatedSellerPIPunch.sellerPIPunchId })
        if (sellerPIPunchRes.failure) {
            setIsLoaderVisible(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'PI Punch Priority', detail: sellerPIPunchRes.data.error }))
        }

        const updatedSellerPIPunches = sellerPIPunch.map(eachSellerPIPunch => {
            if (eachSellerPIPunch.sellerPIPunchId === relatedSellerPIPunch.sellerPIPunchId) {
                return {...eachSellerPIPunch, ...sellerPIPunchRes.data}
            }
            return eachSellerPIPunch
        })
        setSellerPIPunch([...updatedSellerPIPunches])
        setIsLoaderVisible(false)

        dispatch(raiseToast({ severity: 'success', detail: 'Priority raised to high' }))
    }

    const handleSkipVerification = async (relatedSellerPIPunch) => {
        setIsLoaderVisible(true)
        const sellerPIPunchRes = await updateSellerPIPunchSkipVerification({ sellerPIPunchId: relatedSellerPIPunch.sellerPIPunchId })
        if (sellerPIPunchRes.failure) {
            setIsLoaderVisible(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Skip Verification', detail: sellerPIPunchRes.data.error }))
        }

        const updatedSellerPIPunches = sellerPIPunch.map(eachSellerPIPunch => {
            if (eachSellerPIPunch.sellerPIPunchId === relatedSellerPIPunch.sellerPIPunchId) {
                return {...eachSellerPIPunch, ...sellerPIPunchRes.data}
            }
            return eachSellerPIPunch
        })
        setSellerPIPunch([...updatedSellerPIPunches])
        setIsLoaderVisible(false)

        dispatch(raiseToast({ severity: 'success', detail: 'Verification is skipped' }))
    }

    const getVerificationStatus = (relatedSellerPIPunch, relatedProcessLineItem, relatedSellerPIPunchItems, relatedSellerGRNQCPunch, relatedSellerPIPunchTickets) => {
        if(relatedSellerPIPunch.verifiedBy){
            return (
                <div className="flex align-items-center">
                    <span className='text-green-500 font-semibold mr-1 font-semibold border-left-2 border-round-xs p-1'>Verified</span>
                    <i className="pi pi-check-circle text-green-500" />    
                </div>
            )
        }
        else {
            if(relatedSellerPIPunchTickets.length){
                const ticketRaisedUserDetails = usersData.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === relatedSellerPIPunchTickets[0].createdBy)
                let ticketRaisedBy = ''
                if (ticketRaisedUserDetails) {
                    ticketRaisedBy = getFullName(ticketRaisedUserDetails.firstName, ticketRaisedUserDetails.lastName)
                }
                return (
                    <div className={`flex align-items-center process-line-tooltip-${relatedSellerPIPunch.sellerPIPunchId}`}>
                        <span className="text-red-600 font-semibold font-semibold border-left-2 border-round-xs p-1">Ticket Id:</span>
                        <a className="text-red-600 font-semibold underline cursor-pointer" onClick={() => window.open(`/tickets/edit/${relatedSellerPIPunchTickets[0].ticketId}`, '_blank')} target="_blank">{` ${relatedSellerPIPunchTickets[0].ticketId}`}</a>
                        <Tooltip target={`.process-line-tooltip-${relatedSellerPIPunch.sellerPIPunchId}`} showOnDisabled position="right">
                            <div className="flex flex-column m-0">
                                <p className="m-0"><span className="font-semibold">Ticket Raised By:</span>{` ${ticketRaisedBy}`}</p>
                            </div>
                        </Tooltip>
                    </div>
                )
            }
            else if (relatedSellerPIPunch.skippedBy) {
                const skippedByDetails = usersData.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === relatedSellerPIPunch.skippedBy)
                let skippedByName = ''
                if (skippedByDetails) {
                    skippedByName = getFullName(skippedByDetails.firstName, skippedByDetails.lastName)
                }
                return (
                    <div>
                        <span className='text-green-300 font-semibold border-left-2 border-round-xs p-1'>
                            Verification Skipped
                            <Tooltip target={`.skip-verification-tooltip-${relatedSellerPIPunch.sellerPIPunchId}`} showOnDisabled position="right">
                                <div className="flex flex-column m-0">
                                    <p className="m-0"><span className="font-semibold">Verification Skipped By:</span>{` ${skippedByName}`}</p>
                                    <p className="m-0"><span className="font-semibold">Verification Skipped At:</span>{` ${getDateTimeString(relatedSellerPIPunch.skippedAt, "DD.MM.YYYY hh:mm")}`}</p>
                                </div>
                            </Tooltip>
                        </span>
                        <i className={`pi pi-info-circle skip-verification-tooltip-${relatedSellerPIPunch.sellerPIPunchId} ml-1`}></i>
                    </div>
                )
            }

            let isSellerPIPunchProcessed = getGRNProcessingStatus({sellerPIPunchItems: relatedSellerPIPunchItems, sellerGRNQCPunches: relatedSellerGRNQCPunch})
            if(isSellerPIPunchProcessed){
                if (relatedProcessLineItem && relatedProcessLineItem.assigneeId) {
                    const assigneeDetails = usersData.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === relatedProcessLineItem.assigneeId)
                    let assigneeName = ''
                    if (assigneeDetails) {
                        assigneeName = getFullName(assigneeDetails.firstName, assigneeDetails.lastName)
                    }
                    return <span className='text-yellow-400 font-semibold font-semibold border-left-2 border-round-xs p-1'>Under Verification by {assigneeName}</span>
                }
                else {
                    return (
                    <span className='text-yellow-400 font-semibold font-semibold border-left-2 border-round-xs p-1'>Verification in Queue
                        <i className="pi pi-hourglass" />    
                    </span>)
                }
            }
            else{
                return (
                    <div>
                        <span className='text-yellow-400 font-semibold font-semibold border-left-2 border-round-xs p-1'>
                            PI Processing Awaited
                            <Tooltip target=".process-awaited-icon" position="top" content="Please process complete PI on GRN tab" />
                        </span>
                        <i className="pi pi-info-circle process-awaited-icon ml-1"></i>
                    </div>
                )
            }
        }
    }

    const getPIPunchApprovedByManagerStatus = (approvalInstance) => {
        if(!approvalInstance){
            return <></>
        }
    }

    const handleUploadEInvoice = (sellerPIPunch) => {
        setSelectedSellerPIPunch(sellerPIPunch)
        setVisibleSellerEInvoiceModal(true)
    }

    const handleOnUpdateEInvoice = async (EInvoiceDetails) => {
        if (!EInvoiceDetails.EInvoiceNumber){
            return dispatch(raiseToast({severity:'error', detail: 'Please enter E-Invoice Number'}))
        }

        if (!EInvoiceDetails.EInvoiceDate){
            return dispatch(raiseToast({severity:'error', detail: 'Please enter E-Invoice Date'}))
        }

        if (!EInvoiceDetails.EInvoiceDocProof){
            return dispatch(raiseToast({severity:'error', detail: 'Please upload E-Invoice doc proof'}))
        }

        if (window.confirm("Do you want to update the E-Invoice Details?")){

            let updatedData = {
                ...EInvoiceDetails,
                EInvoiceNumber: EInvoiceDetails.EInvoiceNumber.trim(),
                docNo: selectedSellerPIPunch.docNo
            }

            const updateEInvoiceDetailsRes = await updateEInvoiceOnSellerPIPunch(selectedSellerPIPunch.sellerPIPunchId, updatedData)

            if (updateEInvoiceDetailsRes.failure){
                return dispatch(raiseToast({severity:'error', detail: updateEInvoiceDetailsRes.data.error}))
            }

            const updatedSellerPIPunches = sellerPIPunch.map(eachSellerPIPunch => {
                if (eachSellerPIPunch.sellerPIPunchId === selectedSellerPIPunch.sellerPIPunchId){
                    return {...eachSellerPIPunch, EInvoiceDate: EInvoiceDetails.EInvoiceDate, EInvoiceNumber: EInvoiceDetails.EInvoiceNumber, EInvoiceDocProof: updateEInvoiceDetailsRes.data[0].EInvoiceDocProof}
                }
                return eachSellerPIPunch
            })

            setSellerPIPunch(updatedSellerPIPunches)
            setVisibleSellerEInvoiceModal(false)
        }

    }

    const removeSellerPIDocument = (sellerPIPunchId) => {
        const updatedSellerPIPunch = sellerPIPunch.map(eachSellerPIPunch => {
            if(eachSellerPIPunch.sellerPIPunchId === sellerPIPunchId){
                return {...eachSellerPIPunch, sellerPIDocProof: null}
            }
            return {...eachSellerPIPunch}
        })

        setSellerPIPunch(updatedSellerPIPunch)
    }

    let isReuploadPIDocPermitted = false
    const piDocUploadPermissionDetails = checkPermissions({ ...usersData, permissions: [259] })
    if (piDocUploadPermissionDetails.isPermitted) {
        isReuploadPIDocPermitted = piDocUploadPermissionDetails.isPermitted
    }
    
    return(
        <>
            <div className="quality-check" style={{minHeight: "200px"}}>
                {
                    isLoading ? 
                        <div className="flex flex-row justify-content-center">
                            <Oval
                                height="20"
                                width="20"
                                radius="6"
                                color="#000"
                                secondaryColor="#000"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{ position: 'absolute', marginTop: '1.3rem' }}
                                wrapperClassName=""
                                visible={true}
                            />
                        </div>
                    :
                        sellerPIPunch?.map((eachSellerPIPunch, index) => {
                            const relatedSellerPIPunchItems = sellerPIPunchItems?.filter(eachSellerPIPunchItem => eachSellerPIPunchItem.sellerPIPunchId === eachSellerPIPunch.sellerPIPunchId)
                            const relatedSellerGRNQCPunch = sellerGRNQCPunch?.filter(eachSellerGRNQCPunch => eachSellerGRNQCPunch?.sellerPIPunchId === eachSellerPIPunch?.sellerPIPunchId && eachSellerGRNQCPunch?.statusId === 1)
                            const relatedBookingLog = PIPunchBookingLogs.find(eachBookingLog => eachBookingLog.docNo === eachSellerPIPunch.docNo)
                            const relatedProcessLineItem = processLineItems.find(eachProcessLineItem => eachProcessLineItem.linkDocId === eachSellerPIPunch.sellerPIPunchId)
                            const piPunchProcessLineRelatedSubCategories = ticketSubCategoies.filter(subCategory => subCategory.pageRef === "INVOICE_BOOKING")
                            const relatedSubCategoryIds = piPunchProcessLineRelatedSubCategories.map(eachSubCategory => eachSubCategory.ticketSubcategoryId)
                            const relatedSellerPIPunchTickets = sellerPIPunchTickets.filter(eachSellerPIPunchTicket => eachSellerPIPunchTicket.docNo === eachSellerPIPunch.docNo && relatedSubCategoryIds.includes(eachSellerPIPunchTicket.subcategoryId) && eachSellerPIPunchTicket.ticketStatusId === 1)
                            let createdUser = PIPunchCreatedUsers?.find(eachUser => eachUser?.userId === eachSellerPIPunch?.createdBy)
                            let name = getFullName(createdUser?.firstName, createdUser?.lastName)

                            // const relatedApprovalInstance = approvalInstances?.find(eachApprovalInstance => eachApprovalInstance?.docNo === eachSellerPIPunch?.docNo && [12,9].includes(eachApprovalInstance.statusId) && eachApprovalInstance.approvalId == 23) // APPROVAL_CHANGE find by typeId
                            let relatedApprovalInstance = approvalInstances.find(eachApprovalInstance => {
                                const relatedApproval = approvals.find(eachApproval => eachApproval.approvalId === eachApprovalInstance.approvalId)

                                if (pmCompanyConfig.PIPunchApprovalTypeIds.includes(relatedApproval.approvalTypeId) && eachApprovalInstance?.docNo === eachSellerPIPunch?.docNo && [12,9].includes(eachApprovalInstance.statusId)){
                                    return true
                                }
                                return false
                            })

                            let canEditable = false
                            if (eachSellerPIPunch?.createdBy === usersData?.userId){
                                canEditable = true
                            }else {
                                canEditable = getBranchComparision(usersData?.activeUserRoleDetails?.branchId, sellerPO?.pmBranchId)
                            }

                        return (
                            <div className={`p-card py-2 ${eachSellerPIPunch?.statusId === 2 ? 'cancelled-watermark' : ''}`} key={eachSellerPIPunch.sellerPIPunchId}>
                                <div className="flex flex-row justify-content-between align-items-center">
                                    <div className="flex justify-content-between align-items-center" style={{ fontSize: "14px" }}>
                                        <p className='font-bold mr-2'>{index + 1}.</p>
                                        <span className={`font-bold pi-punch-approved-through-manager-tooltip-${eachSellerPIPunch.sellerPIPunchId}`} style={{color: "#00bbaa"}}>{eachSellerPIPunch.docNo}</span>
                                        {relatedApprovalInstance?.statusId === 9 && (
                                            <Tooltip target={`.pi-punch-approved-through-manager-tooltip-${eachSellerPIPunch.sellerPIPunchId}`}>
                                                {getPIPunchApprovedByManagerStatus(relatedApprovalInstance)}
                                            </Tooltip>
                                        )}
                                    </div>
                                    <div className="flex lg:mb-0 align-items-center border-left-2 border-round-xs ml-2" style={{ height: '1.5rem', paddingLeft: "5px", paddingRight: "10px" }}>
                                        <p className='m-0'>Rs.{numberConversion(eachSellerPIPunch?.sellerPICalculatedTotalAmount, numberLocale)}</p>
                                    </div>
                                    {eachSellerPIPunch.statusId !== 2 && 
                                        <div className="flex lg:mb-0 align-items-center">
                                            {eachSellerPIPunch.statusId === 1 && !props.forViewOnly && (
                                                <span>{getVerificationStatus(eachSellerPIPunch, relatedProcessLineItem, relatedSellerPIPunchItems, relatedSellerGRNQCPunch, relatedSellerPIPunchTickets)}</span>
                                            )}
                                        </div>
                                    }
                                    <div className="flex align-items-center justify-content-center font-semibold border-left-2 border-round-xs pl-1 ml-3" style={{ height: '1.5rem' }}>
                                        <p className={`m-0 text-sm font-semibold my-1 pi-punch-approved-through-manager-tooltip-${eachSellerPIPunch.sellerPIPunchId}`}>Created By:</p>
                                        <span style={{ fontWeight: "initial" }} className="text-sm m-0">{name} on {getDateString(eachSellerPIPunch?.createdAt)}</span>
                                    </div>

                                    {/* Right-aligned content */}
                                    { !props.forViewOnly ? 
                                        <div className="flex align-items-center" style={{ marginLeft: 'auto' }}>
                                            <div className="flex flex-row justify-content-center">
                                                <p className="mr-3 font-bold" title={relatedBookingLog?.firstName ? relatedBookingLog?.firstName + " " + relatedBookingLog?.lastName : ""}>
                                                    {relatedBookingLog?.bookedStatus ? "BOOKED" : ""}
                                                </p>
                                            </div>
                                            <EditPIPunch
                                                handleSaveClick={handleSaveClick}
                                                sellerPIPunch={eachSellerPIPunch}
                                                canEditable={canEditable}
                                                usersData={usersData}
                                                relatedApprovalInstance={relatedApprovalInstance}
                                                handleEditClick={handleEditClick}
                                                handleRaisePriority={handleRaisePriority}
                                                handleSkipVerification={handleSkipVerification}
                                                isLoaderVisible={isLoaderVisible}
                                            />
                                            <DeletePI
                                                sellerPIPunch={eachSellerPIPunch}
                                                handleDelete={handleDelete}
                                                handleDeleteGRN={handleDeleteGRN}
                                                sellerGRNQCPunch={relatedSellerGRNQCPunch}
                                                canEditable={canEditable}
                                                isLoaderVisible={isLoaderVisible}
                                            />
                                        </div> 
                                        :
                                        <div className="flex align-items-center" style={{ marginLeft: 'auto' }}></div> 
                                    }
                                </div>
                                    <div className="flex flex-row py-2 p-4 flex-wrap">
                                        <div className="col-2">
                                            <TextInputField name="sellerPINumber" disabled={eachSellerPIPunch.toggleInputs || props?.forViewOnly} labelText="PI Number" errorMessage={!eachSellerPIPunch?.toggleInputs && piPunchErrors?.sellerPINumber} value={eachSellerPIPunch?.sellerPINumber} maxLength={16} keyfiter="int" onChange={e => handleChange(e, eachSellerPIPunch?.sellerPIPunchId)}/>
                                        </div>
                                        <div className="col-2">
                                            <TextInputField name="sellerPITotalAmount" disabled={eachSellerPIPunch.toggleInputs || props?.forViewOnly} labelText="PI Amount" errorMessage={!eachSellerPIPunch?.toggleInputs && piPunchErrors?.sellerPITotalAmount} value={numberConversion(eachSellerPIPunch?.sellerPITotalAmount, numberLocale)} keyfiter="num" onChange={e => handleChange(e, eachSellerPIPunch?.sellerPIPunchId)}/>
                                        </div>
                                        <div className="col-2">
                                            <CalendarField name="sellerPIDate" disabled={eachSellerPIPunch.toggleInputs || props?.forViewOnly} labelText="Seller PI Date" errorMessage={!eachSellerPIPunch?.toggleInputs && piPunchErrors?.sellerPIDate} value={eachSellerPIPunch?.sellerPIDate ? new Date(eachSellerPIPunch?.sellerPIDate) : null} onChange={e => handleChange(e, eachSellerPIPunch?.sellerPIPunchId)}/>
                                        </div>
                                        <div className="flex flex col-12 mb-2 lg:col-2 lg:mb-0">
                                            <div>
                                                <label className="text-xs mb-1">PI Document </label>
                                            {
                                                eachSellerPIPunch.sellerPIDocProof ?
                                                    <div className="flex">
                                                        {
                                                            !eachSellerPIPunch.toggleInputs && !props?.forViewOnly ?
                                                                <div className="m1-2">
                                                                    <FileUpload className="upload-btn w-8rem" mode="basic" name="sellerPIDocProof" accept="image/pdf/*" customUpload uploadHandler={(files) => fileUploadHandler(files, "SELLER_PI_DOCPROOF", eachSellerPIPunch?.sellerPIPunchId)} auto chooseLabel="Upload File" />
                                                                </div>
                                                                : null
                                                        }
                                                        <div className="mt-1">
                                                            <a style={{ textDecoration: "none" }} href={piPunchImageName ? piPunchImageName : eachSellerPIPunch.sellerPIDocProof} className="view-btn mr-3" target="_blank">View</a>
                                                            {/* <a style={{ cursor: !eachSellerPIPunch.toggleInputs ? "pointer" : "not-allowed" }} className={`${eachSellerPIPunch.toggleInputs ? 'text-red-300' : 'text-red-500'}`} name="remove_invoice" onClick={() => !eachSellerPIPunch.toggleInputs ? removeSellerPIDocument(eachSellerPIPunch.sellerPIPunchId) : null}>Remove</a> */}
                                                        </div>
                                                    </div>
                                                    :
                                                    <FileUpload className="upload-btn w-8rem" mode="basic" name="sellerPIDocProof" disabled={eachSellerPIPunch.toggleInputs || props?.forViewOnly} accept="image/pdf/*" customUpload uploadHandler={(files) => fileUploadHandler(files, "SELLER_PI_DOCPROOF", eachSellerPIPunch?.sellerPIPunchId)} auto chooseLabel="Upload File" />
                                            }
                                            </div>
                                            {/* // {
                                            //     eachSellerPIPunch.sellerPIDocProof && 
                                            //     <div className="mt-4 mx-5">
                                            //         <a style={{textDecoration:"none"}} href={piPunchImageName ? piPunchImageName : eachSellerPIPunch.sellerPIDocProof} className="view-btn mr-3" target="_blank">View</a>
                                            //         <a style={{ cursor: !eachSellerPIPunch.toggleInputs ? "pointer" : "not-allowed" }} className="vendor-component-remove-btn" name="remove_invoice" onClick={() => !eachSellerPIPunch.toggleInputs ? removeSellerPIDocument(eachSellerPIPunch.sellerPIPunchId) : null}>Remove</a>
                                            //     </div>
                                            // } */}
                                        </div>
                                        {
                                            pmCompanyConfig.isSellerEInvoiceApplicable && (
                                                eachSellerPIPunch.EInvoiceDocProof ? 
                                                    <div className="mt-4 mx-5">
                                                        {/* <a style={{ textDecoration: "none" }} href={eachSellerPIPunch.EInvoiceDocProof} className="view-btn mr-3" target="_blank" rel="noopener noreferrer">  
                                                            View E-Invoice
                                                        </a> */}
                                                        <FileViewAndRemove doc={{url: eachSellerPIPunch.EInvoiceDocProof}} label={"View E-Invoice"} />  
                                                    </div>
                                                :
                                                    <div className="flex flex-column align-items-center col-12 mt-2 mb-2 lg:col-2 lg:mb-0">
                                                        <Button className="small-btn" label="Upload E-Invoice" onClick={() => handleUploadEInvoice(eachSellerPIPunch)} />
                                                    </div>
                                            )
                                        }

                                    </div>
                                    <div className="flex flex-wrap py-2 w-full mt-2 p-4">
                                            <div className="flex header-style">
                                                <div className="mb-2" style={{ width: '75%', textAlign: "start"}}>Product</div>
                                                <div className="mb-2" style={{ width: '30%' }}>Invoiced Qty</div>
                                            </div>
                                            {
                                                relatedSellerPIPunchItems?.map(eachSellerPIPunchItem => {
                                                    const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial.materialId === eachSellerPIPunchItem.materialId)
                                                    const relatedMaterialBrand = materialBrands?.find(eachMaterialBrand => eachMaterialBrand?.brandId === relatedMaterial?.brandId)
                                                    const material = getMaterialMasterDetailsTooltip({...relatedMaterial, ...relatedMaterialBrand})
                                                    return (
                                                        <div className="flex data-style">
                                                            <div className="py-2" style={{ width: '75%', textAlign: "start", alignSelf: "center"}}>{relatedMaterial?.materialId} | {material}</div>
                                                            <div className="py-2" style={{ width: '30%' , alignSelf: "center"}}>{eachSellerPIPunchItem?.qty}</div>
                                                        </div>
                                                    )
                                                })
                                            }
                                    </div>
                                </div>
                            )
                        })
                }
                {
                    sellerPIPunch?.length === 0 && !isLoading && <p className="font-bold text-center">No PIs for this Seller PO Yet!</p>
                }
                <UploadEInvoiceModal 
                    sellerPIPunch={selectedSellerPIPunch}
                    handleOnUpdateEInvoice={handleOnUpdateEInvoice}
                    visibleSellerEInvoiceModal={visibleSellerEInvoiceModal} 
                    setVisibleSellerEInvoiceModal={setVisibleSellerEInvoiceModal} 
                />

            </div> 
        </>
    )
}

export default PIReceivedProductDetails;